import fixture from './AgentUserRegistrationPassword.post.json';
import { fetchFixture } from 'utils/fetchFixture';
import { API_LOCATION_URL } from 'infrastructure/config';
import {
    IPostInput,
    IPostResponse,
    IAgentUserRegistrationPasswordClient,
} from 'interfaceAdapter/gatewaySchemas/IAgentUserRegistrationPasswordClient';
import { getCookie } from 'utils/cookie';

const csrfToken = getCookie('csrftoken');
const PATH = `${API_LOCATION_URL}/agent/user_registration_password`;

export class AgentUserRegistrationPasswordClient implements IAgentUserRegistrationPasswordClient {
    async post(input: IPostInput): Promise<IPostResponse> {
        const { urlId, password, mock = false } = input;
        const method = 'POST';
        const headers: { [key: string]: string } = {
            'Content-Type': 'application/json',
        };

        if (csrfToken) {
            headers['X-CSRFToken'] = csrfToken;
        }
        const body = JSON.stringify({
            url_id: urlId,
            password,
        });
        try {
            const response = mock
                ? await fetchFixture(fixture)
                : await fetch(PATH, {
                      method,
                      headers,
                      body,
                  });

            const status = response.status;
            const { data, message } = await response.json();

            return {
                data,
                message,
                status,
            };
        } catch {
            throw new Error('処理に失敗しました');
        }
    }
}
